import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";

type ManagePaymentCommandId = Branded<string, "ManagePaymentCommandId">;
const managePaymentCommandIdPrefix = "payment_change_command__";
const {
    factory: managePaymentCommandIdFactory,
    assert: isManagePaymentCommandId,
    zodSchema: managePaymentCommandIdZodSchema,
} = genericId<ManagePaymentCommandId>(managePaymentCommandIdPrefix);

export {
    isManagePaymentCommandId,
    managePaymentCommandIdFactory,
    managePaymentCommandIdPrefix,
    managePaymentCommandIdZodSchema,
};

export type { ManagePaymentCommandId };
